export default class {
    constructor() {
        this.oBlock = jQuery("header.primary");

        this.openMobileMenu();
        this.toggleMobileSubmenu();
    }

    openMobileMenu() {
        // Menu Open/ Close
        jQuery(document).on("click", ".menu-trigger", function (e) {
            jQuery("body").toggleClass("no-scroll");
            jQuery(".menu-trigger .burger-icon").toggleClass("open");
            jQuery("#navigation").toggleClass("open");
            jQuery("#site-overlay").toggleClass("active");
            e.preventDefault();
        });
    }

    toggleMobileSubmenu() {
        $(document).on(
            "click",
            ".navigation li.menu-item-has-children > a",
            function (e) {
                console.log("fg");
                if ($(window).width() < 1229) {
                    $(this).parent().toggleClass("active");
                    $(this).toggleClass("active");
                    // $(this).siblings('.primary-navigation-submenu').slideToggle('400');
                    if (!$(this).siblings(".sub-menu").hasClass("open")) {
                        $(this).siblings(".sub-menu").addClass("open");
                    } else {
                        $(this).siblings(".sub-menu").removeClass("open");
                    }
                    e.preventDefault();
                }
            }
        );
    }
}
